/**
 * Created by piotr.pozniak@thebeaverhead.com on 11/03/2024
 */

import PropTypes from "prop-types";
import { useFeatureFlag } from "../../../hooks/useFeatureFlag";

const FeatureFlag = ({ name, children }) => {
  const canUseFeature = useFeatureFlag(name);

  if (!canUseFeature) {
    return null;
  }

  return children;
};

FeatureFlag.defaultProps = {};

FeatureFlag.propTypes = {
  name: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};

export default FeatureFlag;
